import {ALERT_SET_ID} from './types';

export const showAlert = (payload: {id: string; modalProps?: {}}) => ({
  type: ALERT_SET_ID,
  payload,
});

export const hideAlert = () => {
  return {
    type: ALERT_SET_ID,
    payload: {id: '', modalProps: {}},
  };
};
